import React, { useState, MouseEvent, useContext } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
import FlaggedIssueViewModel from '../ViewModels/FlaggedIssueViewModel';
import { APIContext } from '../../Contexts/APIContext';
import { AppContext } from '../../Contexts/AppContext';
import Popover from '@mui/material/Popover';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';

type Props = {
    flaggedIssue: FlaggedIssueViewModel;
    getData: () => void;
}

export default function FlaggedIssuesModalRow({ flaggedIssue, getData }: Props) {
    const { isAdmin, get } = useContext(APIContext);
    const { userDetails } = useContext(AppContext);
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const openActions = (e: MouseEvent<HTMLButtonElement>) => setAnchorEl(e.currentTarget);
    const closeActions = () => {
        setAnchorEl(null);
        getData();
    }

    const markAsRemoved = () => {
        get('MonitoringScorecard', `MarkFlaggedIssueAsRemoved?id=${flaggedIssue.id}`, (data) => {
            closeActions();
        });
    }

    return (
        <TableRow>
            <TableCell>{flaggedIssue.section}</TableCell>
            <TableCell>{flaggedIssue.question}</TableCell>
            <TableCell sx={{ wordBreak: 'break-all', overflowWrap: 'break-word' }}>{flaggedIssue.notes}</TableCell>
            <TableCell>{flaggedIssue.username}</TableCell>
            <TableCell>{flaggedIssue.status}</TableCell>
            <TableCell>
                <IconButton onClick={openActions}><MenuIcon /></IconButton>
            </TableCell>
            <Popover
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                open={Boolean(anchorEl)}
                style={{ zIndex: 99 + " !important" }}
                anchorEl={anchorEl}
            >
                <ClickAwayListener onClickAway={closeActions}>
                    <ButtonGroup orientation="vertical" color="primary" variant="contained">
                        <Button onClick={markAsRemoved} disabled={!(isAdmin || userDetails.name === flaggedIssue.username)}>Mark as Removed</Button>
                    </ButtonGroup>
                </ClickAwayListener>
            </Popover>
        </TableRow>
    )
}